module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic14.aaf66a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic14.png
// module id = 479
// module chunks = 1